import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSidebar } from '../context/SidebarContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const sidebar = useSidebar();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const hasSidebar = location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/admin');

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <span className="navbar-mark">N</span>
          NodexaRPC
        </Link>
        <nav className="navbar-links">
          <Link to="/pricing">Pricing</Link>
          <Link to="/api-credits">API Credits</Link>
          {user && (user?.isAdmin ? <Link to="/admin">Dashboard</Link> : <Link to="/dashboard">Dashboard</Link>)}
        </nav>
        <div className="navbar-cta">
          {user ? (
            <button className="btn btn-outline btn-sm" onClick={handleLogout}>Log out</button>
          ) : (
            <>
              <Link to="/login" className="btn btn-outline btn-sm">Log in</Link>
              <Link to="/signup" className="btn btn-primary btn-sm">Start building free</Link>
            </>
          )}
        </div>
        {hasSidebar && sidebar && (
          <button
            type="button"
            className="sidebar-toggle"
            aria-label="Toggle menu"
            aria-expanded={sidebar.open}
            onClick={() => sidebar.setOpen((o) => !o)}
          >
            <span className="sidebar-toggle-lines">
              <span></span><span></span><span></span>
            </span>
          </button>
        )}
      </div>
    </header>
  );
}
